//REDUX-TOOLKIT
import { createSlice, PayloadAction } from "@reduxjs/toolkit"


interface State {
    links: any,
    pagesEnable: any
}

const initialState: State = {
    links: [],
    pagesEnable: null
}


const slice = createSlice({
    name: "setting",
    initialState,
    reducers: {
        setLink: (state, action: PayloadAction<any>) => {
            return { ...state, links: action.payload }
        },
        setPagesEnable: (state, action: PayloadAction<any>) => {
            return { ...state, pagesEnable: action.payload }
        }
    }
})


export const { setLink, setPagesEnable } = slice.actions;
export const selectSetting = (state: { setting: State }) => state.setting;
export default slice.reducer;